import { openModal } from '@mantine/modals';
import Cookies from 'js-cookie';
import { useLocation, useNavigate } from 'react-router-dom';

import { refreshToken as refreshTokenRequest } from '@mygpt/app/apis';

import {
  COOKIE_DOMAIN,
  KEY_MYGPT_PATH_NAME,
  KEY_MYGPT_REFRESH_TOKEN,
  KEY_MYGPT_TOKEN,
  KEY_MYGPT_TOKEN_EXPIRESIN,
} from '@/constant';
import { TokenInfo } from '@/types/interface';
import { saveTokenInfo } from '@/utils/tool';

const getLocalLogin = () => {
  return window.location.origin + '/auth/login';
};

const getLoginUrl = () => {
  return import.meta.env.VITE_API_BASE_URL + '/login';
};

export const login = (redirectUrl?: string) => {
  const urlParam = redirectUrl ? `&state=${btoa(encodeURI(redirectUrl))}` : '';
  let loginUrl = getLoginUrl() + '?response_type=code' + urlParam;

  // redirect_uri： 由后端环境控制是否使用该参数跳到本地登录页
  loginUrl += `&redirect_uri=${encodeURI(getLocalLogin())}`;

  openModal({
    centered: true,
    withCloseButton: false,
    closeOnClickOutside: false,
    radius: 'md',
    children: 'loading ...',
  });

  window.location.href = loginUrl;
};

export const deleteTokenInfo = () => {
  // localStorage.removeItem(KEY_MYGPT_TOKEN);
  // localStorage.removeItem(KEY_MYGPT_REFRESH_TOKEN);
  // localStorage.removeItem(KEY_MYGPT_TOKEN_EXPIRESIN);
  Cookies.remove(KEY_MYGPT_TOKEN, { domain: COOKIE_DOMAIN });
  Cookies.remove(KEY_MYGPT_REFRESH_TOKEN, { domain: COOKIE_DOMAIN });
  Cookies.remove(KEY_MYGPT_TOKEN_EXPIRESIN, { domain: COOKIE_DOMAIN });
};

export const useLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const logout = () => {
    deleteTokenInfo();

    // redirect_uri： 由后端环境控制是否使用该参数跳到本地登录页
    window.location.href = import.meta.env.VITE_API_BASE_URL + `/logout?redirect_uri=${encodeURI(getLocalLogin())}`;
  };

  const signup = (path?: string) => {
    savePath(path);
    window.location.href = import.meta.env.VITE_API_BASE_URL + '/login?screen_hint=signup';
  };

  const savePath = (path?: string) => {
    if (!path) return;
    const pathName = path ? path : location.pathname;
    // 记录path，登录回来后自动跳到该地址
    sessionStorage.setItem(KEY_MYGPT_PATH_NAME, pathName);
  };

  const loginCallback = () => {
    const pathname = sessionStorage.getItem(KEY_MYGPT_PATH_NAME);
    if (pathname && pathname !== location.pathname) {
      navigate(pathname);
    } else {
      navigate('/');
    }
    sessionStorage.removeItem(KEY_MYGPT_PATH_NAME);
  };

  // 刷新token
  const refreshToken = async () => {
    const refresh_token = Cookies.get(KEY_MYGPT_REFRESH_TOKEN);
    if (!refresh_token) return;
    const res = await refreshTokenRequest({ refresh_token });
    if (!res.data) return;
    const data: TokenInfo = res.data;
    saveTokenInfo(data);
    scheduleTokenRenewal();
    return data;
  };
  const scheduleTokenRenewal = () => {
    const expiresIn = Cookies.get(KEY_MYGPT_TOKEN_EXPIRESIN) || 0;
    if (!expiresIn) return;

    const now = new Date().getTime();
    const delay = Number(expiresIn) - now - 60000;

    if (delay <= 0) return;

    setTimeout(() => {
      refreshToken();
    }, delay);
  };

  return {
    login,
    logout,
    signup,
    loginCallback,
    getLoginUrl,
    refreshToken,
    scheduleTokenRenewal,
  };
};
